var React = require('react');

function Send (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.184 24.195c.808 0 1.394-.691 1.804-1.746l7.278-19.031c.199-.504.304-.95.304-1.324 0-.75-.457-1.219-1.207-1.219-.375 0-.82.117-1.324.316L1.914 8.516c-.937.351-1.652.937-1.652 1.757 0 1.032.785 1.395 1.851 1.723L8.02 13.79c.726.223 1.136.211 1.64-.258l12.223-11.39c.152-.13.316-.118.433 0 .118.105.13.28 0 .433L10.961 14.832c-.445.469-.48.89-.258 1.64l1.735 5.778c.34 1.113.703 1.945 1.746 1.945z","fill":"#2380FF","fillRule":"nonzero"}));
}

Send.defaultProps = {"width":"24","height":"25"};

module.exports = Send;

Send.default = Send;
